export enum AvailableLanguages {
  EN = 'en',
  RU = 'ru',
  FR = 'fr',
}

/**
 * Determines user's browser language
 * @returns Browser language code (e.g., 'ru', 'en', 'fr')
 */
export const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  // Get base language code (e.g., 'ru' from 'ru-RU')
  const langCode = browserLang.split('-')[0].toLowerCase();
  return langCode;
};

/**
 * Checks if browser language is supported
 * @param browserLang Browser language code
 * @returns Supported language code or null
 */
export const getSupportedBrowserLanguage = (browserLang: string): string | null => {
  const supportedLanguages = Object.values(AvailableLanguages);
  if (supportedLanguages.includes(browserLang as AvailableLanguages)) {
    return browserLang;
  }
  return null;
};

/**
 * Gets language for application initialization
 * Priority: localStorage > browser language (if supported) > 'en'
 * Automatically saves browser language to localStorage on first launch if it's supported
 * @returns Language code to use
 */
export const getInitialLanguage = (): string => {
  // First check localStorage
  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // Then check browser language
  const browserLang = getBrowserLanguage();
  const supportedLang = getSupportedBrowserLanguage(browserLang);
  if (supportedLang) {
    // Save browser language to localStorage on first launch
    localStorage.setItem("language", supportedLang);
    return supportedLang;
  }
  
  // Default to English
  return AvailableLanguages.EN;
};
